//
/* GS://PROTOCOLO
 * Arquivo: src/components/pos/Receipt.js
 * Versão: 2.1.0 – FEATURE: Exibição de Troco no Recibo
 *
 * Mudanças desta versão:
 * - ADD: Renderização condicional de "Valor Pago" e "Troco" se disponíveis nos dados.
 */
//

import React from 'react';

// Usamos um Componente de Classe aqui porque a biblioteca react-to-print funciona melhor com refs de classe
class Receipt extends React.Component {
  render() {
    const { data } = this.props;

    if (!data) {
      return <div style={{ display: 'none' }} />;
    }

    const {
      customerName,
      items,
      subtotal,
      discountPoints,
      discountManualPercentage,
      total,
      paymentMethod,
      createdBy,
      customerId,
      pointsEarned,
      finalPointsBalance,
      amountPaid, // Novo campo
      change      // Novo campo
    } = data;
    
    const manualDiscountAmount = subtotal * (discountManualPercentage / 100);
    const date = new Date().toLocaleString('pt-BR');
    const isRegisteredCustomer = customerId !== 'consumidor-final';

    return (
      <div style={{ fontFamily: 'monospace', fontSize: '12px', color: '#000', padding: '15px', width: '280px', border: '1px solid #eee', backgroundColor: 'white' }}>
        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
          <h2 style={{ margin: '0', fontSize: '16px' }}>GoldenSisters semijoias</h2>
          <p style={{ margin: '0' }}>Comprovante de Venda</p>
        </div>
        
        <p style={{ margin: '2px 0' }}>Data: {date}</p>
        <p style={{ margin: '2px 0' }}>Cliente: {customerName}</p>
        <p style={{ margin: '2px 0' }}>Operador(a): {createdBy?.name || 'N/A'}</p>
        
        <hr style={{ border: 'none', borderTop: '1px dashed #000', margin: '10px 0' }} />

        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', paddingBottom: '5px' }}>Item</th>
              <th style={{ textAlign: 'center', paddingBottom: '5px' }}>Qtd</th>
              <th style={{ textAlign: 'right', paddingBottom: '5px' }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {items && items.map((item, index) => (
              <tr key={index}>
                <td style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name}</td>
                <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                <td style={{ textAlign: 'right' }}>R${(item.price * item.quantity).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <hr style={{ border: 'none', borderTop: '1px dashed #000', margin: '10px 0' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Subtotal:</span>
          <span>R$ {subtotal.toFixed(2)}</span>
        </div>

        {discountPoints > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Desc. Pontos:</span>
            <span>- R$ {discountPoints.toFixed(2)}</span>
          </div>
        )}

        {manualDiscountAmount > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Desc. Manual ({discountManualPercentage}%):</span>
            <span>- R$ {manualDiscountAmount.toFixed(2)}</span>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '14px', marginTop: '5px' }}>
          <span>TOTAL:</span>
          <span>R$ {total.toFixed(2)}</span>
        </div>

        {/* [GS-NEW] Seção de Troco */}
        {amountPaid > 0 && (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                    <span>Valor Pago:</span>
                    <span>R$ {amountPaid.toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Troco:</span>
                    <span>R$ {(change || 0).toFixed(2)}</span>
                </div>
            </>
        )}

        <div style={{ marginTop: '10px' }}>
          <p style={{ margin: '2px 0' }}>Pagamento: {paymentMethod}</p>
        </div>

        {isRegisteredCustomer && (
            <>
                <div style={{marginTop: '10px'}}></div>
                <hr style={{ border: 'none', borderTop: '1px dashed #000', margin: '10px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Pontos Ganhos:</span>
                    <span>+{pointsEarned || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Saldo Final:</span>
                    <span>{finalPointsBalance || 0} GP</span>
                </div>
            </>
        )}

        <div style={{ height: '20px' }}></div> 

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p style={{ margin: '0', fontStyle: 'italic' }}>
            Agradecemos sua compra na GoldenSisters e aguardamos seu retorno.
          </p>
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px', paddingTop: '10px', borderTop: '1px dashed #000' }}>
            <p style={{ margin: '0', fontSize: '10px', fontWeight: 'bold' }}>GoldenSisters semijoias</p>
            <p style={{ margin: '0', fontSize: '10px' }}>CNPJ: 55.137.637/0001-16</p>
        </div>
      </div>
    );
  }
}

export default Receipt;